// extracted by mini-css-extract-plugin
export default {"support_image":"support_support_image__jQLLm","support_image__bg":"support_support_image__bg__VJDMD","support_contact_btn":"support_support_contact_btn__UgRAu"};